import { Calendar, MapPin, DollarSign, Tag } from 'lucide-react';

export default function ItineraryHeader({ itinerary, pageTheme }) {

  const {
    packageTrendsPageBackground,
    packageTrendsPageCardBackground,
    packageTrendsPagePrimaryColor,
    packageTrendsPageSecondColor,
    packageTrendsPageThirdColor,
    packageTrendsPageFourthColor,
  } = pageTheme;

  return (
    <header style={{zIndex: 2}} className="relative h-[60vh] min-h-[400px] w-full overflow-hidden">
      <img
        src={itinerary.image}
        alt={itinerary.destination}
        className="absolute inset-0 h-full w-full object-cover"
        referrerPolicy="no-referrer"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/40 to-transparent"></div>
      
      <div className="absolute inset-0 flex flex-col justify-end p-6 md:p-12 lg:p-20">
        <div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-4xl"
        >
          <div className="flex flex-wrap items-center gap-3 mb-4">
            <span className="px-3 py-1 rounded-full bg-white/20 backdrop-blur-md text-white text-xs font-semibold uppercase tracking-wider border border-white/30">
              {itinerary.short_tag || "NO TAG"}
            </span>
            <span className="flex items-center gap-1 text-white/80 text-sm">
              <MapPin className="w-4 h-4" />
              {itinerary.destination}
            </span>
          </div>
          
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 tracking-tight font-serif">
            {itinerary.purpose}
          </h1>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-12">
            <div className="flex items-center gap-3">
              <div className="p-2 rounded-lg bg-white/10 backdrop-blur-sm">
                <Calendar className="w-5 h-5 text-white" />
              </div>
              <div>
                <p className="text-white/60 text-xs uppercase tracking-widest">Dates</p>
                <p className="text-white font-medium">
                  {new Date(itinerary.start_date).toLocaleDateString()} - {new Date(itinerary.end_date).toLocaleDateString()}
                </p>
              </div>
            </div>
            
            <div className="flex items-center gap-3">
              <div className="p-2 rounded-lg bg-white/10 backdrop-blur-sm">
                <DollarSign className="w-5 h-5 text-white" />
              </div>
              <div>
                <p className="text-white/60 text-xs uppercase tracking-widest">Price</p>
                <p className="text-white font-medium">
                  {itinerary.price.toLocaleString()} {itinerary.price_currency.toUpperCase()}
                </p>
              </div>
            </div>

            <div className="flex items-center gap-3">
              <div className="p-2 rounded-lg bg-white/10 backdrop-blur-sm">
                <Tag className="w-5 h-5 text-white" />
              </div>
              <div>
                <p className="text-white/60 text-xs uppercase tracking-widest">Status</p>
                <p className="text-white font-medium">
                  {itinerary.is_published ? 'Confirmed' : 'Draft'}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
